import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpHeaders
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

export interface ReqErrorConfigModel {
  showError: boolean;
  defaultMessage: string;
}

@Injectable({
  providedIn: 'root'
})
export class HttpInterceptorService implements HttpInterceptor {
  constructor() {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const authReq = req.clone({
      headers: this.addHeaders(req)
    });

    return next.handle(authReq);
  }

  private addHeaders(req: HttpRequest<any>): HttpHeaders {
    const headers =
      req.headers instanceof HttpHeaders ? req.headers : new HttpHeaders();

    return headers
      .set('pragma', 'no-cache')
      .set('Cache-Control', 'no-cache')
      .set('If-Modified-Since', 'Mon, 26 Jul 1997 05:00:00 GMT');
  }
}
